/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationsUserFilterCode } from './NotificationsUserFilterCode';
import {
    NotificationsUserFilterCodeFromJSON,
    NotificationsUserFilterCodeFromJSONTyped,
    NotificationsUserFilterCodeToJSON,
} from './NotificationsUserFilterCode';

/**
 * 
 * @export
 * @interface NotificationsFilterResponse
 */
export interface NotificationsFilterResponse {
    /**
     * 
     * @type {Array<NotificationsUserFilterCode>}
     * @memberof NotificationsFilterResponse
     */
    results?: Array<NotificationsUserFilterCode>;
    /**
     * 
     * @type {number}
     * @memberof NotificationsFilterResponse
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsFilterResponse
     */
    lead_id?: number;
}

/**
 * Check if a given object implements the NotificationsFilterResponse interface.
 */
export function instanceOfNotificationsFilterResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function NotificationsFilterResponseFromJSON(json: any): NotificationsFilterResponse {
    return NotificationsFilterResponseFromJSONTyped(json, false);
}

export function NotificationsFilterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsFilterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(NotificationsUserFilterCodeFromJSON)),
        'count': json['count'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
    };
}

export function NotificationsFilterResponseToJSON(value?: NotificationsFilterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(NotificationsUserFilterCodeToJSON)),
        'count': value.count,
        'lead_id': value.lead_id,
    };
}

